import { actionAuth } from "../Store/slices/AuthSlice";

export async function saveTokenInLocalStorage(candidate) {
  await localStorage.setItem("candidate", JSON.stringify(candidate));
}

export async function checkAutoLogin(dispatch) {
  const tokenDetailsString = await localStorage.getItem("candidate");
  let tokenDetails = "";
  if (!tokenDetailsString) {
    return;
  }

  tokenDetails = JSON.parse(tokenDetailsString);
  if (tokenDetails?.data !== undefined && tokenDetails?.token !== undefined) {
    dispatch(actionAuth(tokenDetails));
  }
}

export async function getToken() {
  const tokenDetailsString = await localStorage.getItem("candidate");
  let tokenDetails = "";
  if (!tokenDetailsString) {
    return false;
  }
  tokenDetails = JSON.parse(tokenDetailsString);
  return tokenDetails?.token;
}
